export default "https://legacy.eskolare-development.com/images/default-cover.png";